export default __webpack_public_path__ + "static/media/use-your-own-devices.44ce1f13.jpg";